"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadowStyle = exports.shadowOptions = void 0;

var _styledComponents = require("styled-components");

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      box-shadow: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var shadowOptions = {
  shadow300: 'shadow300',
  shadow500: 'shadow500',
  shadow700: 'shadow700',
  none: null
};
exports.shadowOptions = shadowOptions;

var shadowStyle = function shadowStyle(theme, shadow) {
  if (shadow) {
    return (0, _styledComponents.css)(_templateObject(), theme.shadows[shadow]);
  }

  return (0, _styledComponents.css)(_templateObject2());
};

exports.shadowStyle = shadowStyle;